import { CommonModule, NgSwitch } from '@angular/common'
import { Component, inject, OnInit } from '@angular/core'
import { EarningsComponent } from '../earnings/earnings.component'
import { ReviewComponent } from '../review/review.component'
import { SuccessComponent } from '../success/success.component'
import { Store } from '@ngrx/store'
import { selectRunningPayroll } from '../../../store/payroll/payroll.reducers'
import { filter, take, tap } from 'rxjs'
import { PayrollStatus } from '../../../store/payroll/payroll.state'
import { Router, RouterModule } from '@angular/router'
import { eps } from '../../../services/url.service'
import { runningPayrollActions } from '../../../store/payroll/payroll.actions'

@Component({
  selector: 'app-run-payroll',
  imports: [
    NgSwitch,
    CommonModule,
    RouterModule,
    EarningsComponent,
    ReviewComponent,
    SuccessComponent
  ],
  templateUrl: './run-payroll.component.html',
  styleUrl: './run-payroll.component.scss'
})
export class RunPayrollComponent implements OnInit {
  private store = inject(Store)
  private router = inject(Router)
  eps = eps
  screens = [0, 1, 2]
  runningPayroll$ = this.store.select(selectRunningPayroll)

  //---State---//
  currentScreenIndex = 0

  ngOnInit(): void {
    this.store.dispatch(runningPayrollActions.clearPreviousSalaries())
    this.store.dispatch(runningPayrollActions.clearArrearLopDays())
    this.runningPayroll$
      .pipe(
        filter(runningPayroll => runningPayroll !== undefined),
        take(1),
        tap(runningPayroll => {
          if (runningPayroll === null) this.router.navigate([eps.hrm.managePayrollPath])
          if (
            runningPayroll?.status === PayrollStatus.PROCESSED ||
            runningPayroll?.status === PayrollStatus.PAID
          ) {
            this.currentScreenIndex = 1
          }
        })
      )
      .subscribe()
  }

  changeScreen(value: boolean) {
    if (value) this.currentScreenIndex++
    else this.currentScreenIndex--
  }
}
